import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import type { LifecycleStage } from '@/constants/lifecycleStages';
import { MAINTENANCE_PROJECTS_KEY, MAINTENANCE_STATS_KEY } from '@/lib/queryKeys/maintenanceKeys';

interface Args {
  projectId: string;
  override: LifecycleStage | null; // null = auto
}

const isRlsError = (err: any): boolean => {
  const msg = (err?.message || '').toLowerCase();
  return (
    err?.code === '42501' ||
    msg.includes('row-level security') ||
    msg.includes('permission denied') ||
    msg.includes('insufficient_privilege')
  );
};

export const useUpdateLifecycleOverride = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ projectId, override }: Args) => {
      const { error } = await supabase
        .from('projects')
        .update({ lifecycle_stage_override: override } as any)
        .eq('id', projectId);
      if (error) throw error;
    },
    onSuccess: (_d, { projectId }) => {
      qc.invalidateQueries({ queryKey: ['project', projectId] });
      qc.invalidateQueries({ queryKey: ['project-edit', projectId] });
      qc.invalidateQueries({ queryKey: [MAINTENANCE_PROJECTS_KEY] });
      qc.invalidateQueries({ queryKey: [MAINTENANCE_STATS_KEY] });
      toast.success('Đã cập nhật Trạng thái');
    },
    onError: (err: any) => {
      if (isRlsError(err)) toast.error('Bạn không có quyền sửa Trạng thái');
      else toast.error(err?.message || 'Cập nhật Trạng thái thất bại');
    },
  });
};
